import { InitPage } from "../index";

declare var $;
declare var App: any;
declare const tenantCode: string;

export interface LsProgressChannelData {
  message: string;
  progress: number;
  state: string;
}

class LsProgressUpdate {
  lsProgressUpdateChannel: any;

  constructor() {
    if(!tenantCode) return;

    this.lsProgressUpdateChannel = App.cable.subscriptions.create(
      {
        channel: "Lightspeed::SyncProgressChannel",
        tenant_code: tenantCode
      },
      {
        connected() {
          console.log("Connected to Lightspeed Progress Update Channel");
        },
        disconnected() {
          console.log("Disconnected to Lightspeed Progress Update Channel");
        },
        received: (data: any) => this.updateProgress(data)
      }
    );
  }
  updateProgress(data: LsProgressChannelData) {
    console.log(data);
    $('#ls_sync').show();
    $('#ls_sync_progress').text(data.message);
    $('.progress-bar').css('width', `${data.progress}%`);
    $('#progressLabel').text(`${data.progress}%`)
    if ((data.state == 'complete') && ($('#ls_sync_progress').length > 0)) {
      this.refresh();
    }
  }
  refresh(): void {
    setTimeout(() => window.location.reload(), 10000);
  }
}

export function LoadPage() {
  InitPage("compare_v2", () => {
    const m = new LsProgressUpdate();
  });

  InitPage("items", () => {
    const m = new LsProgressUpdate();
  });
}
